module.exports = __webpack_public_path__ + "img/2.6cb5e08d.jpg";